module.exports = __webpack_public_path__ + "img/button-s_fwt21.1154a58.png";